export const USERS_TABLE = "users";
export const USERS_DIRECTORY_VIEW = "users_directory";

export const USER_PROFILE_FIELDS = [
  "id",
  "username",
  "name",
  "role",
  "created_at",
  "cod_rep",
  "comision",
  "ver_comisiones_globales",
  "active",
].join(", ");

export const USER_DIRECTORY_FIELDS = [
  "id",
  "name",
  "role",
  "created_at",
  "cod_rep",
  "comision",
  "ver_comisiones_globales",
  "active",
].join(", ");

export const USER_ADMIN_FIELDS = [
  USER_PROFILE_FIELDS,
  "password",
].join(", ");
